module.exports = __webpack_public_path__ + "6bc2c17/img/group-27.e62dc3d2.svg";